// extracted by mini-css-extract-plugin
module.exports = {"commonText":"CommonTextBlock-module--commonText--1KIv4","commonTextListItem":"CommonTextBlock-module--commonTextListItem--bQxDJ"};